import { useEffect, useState } from "react";
import { Button, Table } from "antd";
import { exportDataAsExcel } from "helpers/helpfulFunctions";

function GridTable({
  loading,
  columns,
  dataSource,
  rowId,
  allowExport,
  apiExport,
  onExport,
  isExporting,
  exportConfig,
  title,
  soldOrders,
  onChange,
  rowClassName,
  currentPage,
  totalCount,
  onPageChange,
  pageSize,
  onPageSizeChange,
  ordersTotalPrice,
  rowSelection,
  selectedUsers,
  onViewUsersBalances
}) {
  const [filteredData, setFilteredData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  const exportAllUserAsExcel = () => {
    if (apiExport) {
      onExport()
    } else {
      let currentData = filteredData.length === 0 ? structuredClone(dataSource) : structuredClone(filteredData)
      if (soldOrders) {
        currentData.unshift({ totalQuantity: soldOrders.totalQuantity, totalPrice: soldOrders.totalPrice })
      }
      exportDataAsExcel(currentData, exportConfig)
    }
  }

  useEffect(() => {
    if (title === "FinancialOrders" && dataSource) {
      const arr = filteredData.length > 0 ? filteredData : dataSource;
      const totalPrice = arr.reduce((pre, curr) => pre + parseFloat(curr.price), 0)
      setTotalPrice(totalPrice.toFixed(2))
    }
  }, [filteredData, dataSource, title]);


  return (
    <>
      <div className="d-flex justify-content-end gap-3 mb-3">
        {title === "Users" && selectedUsers?.length > 1 ? (
          <Button
            onClick={onViewUsersBalances}
            className="d-block"
            style={{
              color: "rgb(53, 106, 179)",
              borderColor: "rgb(53, 106, 179)"
        }}
          >
        View Balance
      </Button>
      ) : (
      ""
        )}
      {allowExport ? (
        <Button
          onClick={exportAllUserAsExcel}
          className="d-block"
          loading={isExporting}
        >
          Export To Excel
        </Button>
      ) : (
        ""
      )}
    </div >
      { title === "Orders" || title === "FinancialOrders" ? (
      <p>
        <span className="fw-bold">Total Price: </span>
        {parseFloat(title === "Orders" ? ordersTotalPrice : totalPrice).toLocaleString()} EGP
      </p>
    ) : (
      ""
    )
}
<Table
  loading={loading}
  columns={columns}
  dataSource={dataSource}
  rowKey={(row) => row[rowId]}
  scroll={{ x: 600 }}
  rowSelection={rowSelection}
  onChange={(pagination, filters, sorter, extra) => {
    if (extra.action === "filter") {
      setFilteredData(extra.currentDataSource)
    }
    if (onChange) {
      onChange(pagination, filters, sorter, extra)
    }
  }}
  rowClassName={rowClassName ? rowClassName : (record, index) =>
    index % 2 === 0 && "background-even-records"
  }
  pagination={{
    pageSize: pageSize,
    defaultPageSize: 10,
    responsive: true,
    hideOnSinglePage: false,
    current: currentPage,
    total: totalCount,
    onChange: onPageChange,
    onShowSizeChange: onPageSizeChange,
    showSizeChanger: true
  }}
/>
    </>
  );
}

export default GridTable;
